<template>
    <v-container fluid>   
      <LeftMenu/> 
        <v-layout row wrap>   
          <v-flex xs12>
            <Progress :show="this.showProgress" />
          </v-flex>
          <v-flex xs1></v-flex>
          <v-flex xs11>
            <v-data-table
              v-model="selectedAssumptions"
              :headers="headers"
              :items="assumptionsFormatted"
              :items-per-page="50"
              item-key="id"
              sort-by="assumptionDate"
              show-select
              :sort-desc=true
              class="elevation-1"
              :search="search"
              :custom-filter="filterOnlyCapsText"
              >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Budget Assumptions</v-toolbar-title>
                  <v-divider
                    class="mx-4"
                    inset
                    vertical
                  ></v-divider>
                  <v-flex xs2 class="pr-3">
                    <v-combobox
                          :items="periodList"
                          label="Select Start Period"
                          item-text="text"
                          v-model="assumptionSelectedStartDate"
                          single-line
                          return-object
                          v-on:change="assumptionStartPeriodChanged"
                        ></v-combobox>
                  </v-flex>
                  <v-flex xs2 class="pr-3">  
                    <v-combobox
                            :items="periodList"
                            label="Select End Period"
                            item-text="text"
                            v-model="assumptionSelectedEndDate"
                            single-line
                            return-object
                            v-on:change="assumptionEndPeriodChanged"
                        ></v-combobox>               
                  </v-flex> 
                   <v-flex xs3>
                    <v-text-field v-model="search" label="Search " class="mx-4"></v-text-field>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn color="primary" :disabled="assumptionSelectedStartDate.defaultsCreated" dark class="mb-2" @click="createDefaults()">Create Defaults</v-btn>
                  </v-flex>
                  <v-flex xs2>
                    <v-btn color="primary" dark class="mb-2" v-on="on">Transfer To Next</v-btn>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-dialog v-model="dialog" max-width="1200px">
                    <template v-slot:activator="{ on }">
                      <v-btn color="primary" dark class="mb-2" v-on="on">New Assumption</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                         
                            <v-flex xs12 sm6 md2>                              
                              <v-combobox
                                :items="periodList"
                                label="Select Period"
                                v-model="editedItem.period"
                                item-text="text"
                                single-line
                                return-object
                            ></v-combobox> 
                            </v-flex> 
                            <v-flex xs12 sm6 md5>
                              <v-combobox
                                :items="masterCategoryList"
                                label="Select Master Category"
                                v-model="selectedMasterCategory"
                                item-text=""
                                single-line
                                return-object
                                v-on:change="getCategoriesByMaster"
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md5>
                              <v-combobox
                                :items="categoryList"
                                label="Select Category"
                                v-model="editedItem.expenseCategory"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex> 
                            <v-flex xs12 sm6 md4>                              
                              <v-combobox
                                :items="departmentList"
                                label="Select Department"
                                v-model="editedItem.department"
                                item-text="name"
                                single-line
                                return-object
                            ></v-combobox> 
                            </v-flex> 
                            <v-flex xs12 sm6 md4>
                              <v-currency-field :key="editedItem.id" v-model="editedItem.amount" label="Amount"></v-currency-field>
                            </v-flex>
                             
                            <v-flex xs12 sm6 md4>
                              <v-combobox
                                :items="currencyListWithText"
                                label="Select Currency"
                                v-model="editedItem.currency"
                                item-text="text"
                                single-line
                                return-object
                              ></v-combobox>
                            </v-flex>  
                            <v-flex xs12 sm6 md4/>
                              
                            <v-flex xs12 sm6 md12>
                              <v-text-field v-model="editedItem.title"  label="Title"></v-text-field>
                            </v-flex>                         
                            <v-flex xs12 sm6 md12>
                              <v-textarea v-model="editedItem.explanation"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Explanation"></v-textarea>
                            </v-flex>                                                                                                                                                                       
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="close">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  
                  <v-dialog v-model="approvalDialog" max-width="1000px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ approvalDialogTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                         
                            <v-flex xs12 sm6 md12>                              
                              <v-data-table
                                :headers="approvalHeaders"
                                :items="approvalDialogItem.takenActions"
                                :items-per-page="50"
                                item-key="id"
                                sort-by="actionDate"
                                class="elevation-1"
                                hide-default-footer
                                >
                              </v-data-table>
                            </v-flex> 
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeApprovalDialog">Cancel</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-dialog v-model="commentDialog" max-width="400px">
                    <v-card>
                      <v-card-title>
                        <span class="headline">{{ commentDialogTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>                                                         
                           <v-flex xs12 sm6 md12>
                              <v-textarea v-model="commentDialogValue"  :outlined="true"
                              :auto-grow="true" :clearable="true"
                              label="Comment"></v-textarea>
                            </v-flex>    
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" dark class="mb-2" @click="closeCommentDialog">Cancel</v-btn>
                        <v-btn color="success" dark class="mb-2" @click="saveComment">Save</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
                <v-layout row wrap>
                  <v-flex xs1 align-self-center="true" >
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <v-icon   
                      v-if="selectedAssumptions.length>0"
                      color="green"
                      @click="approveAll()">
                      mdi-checkbox-marked-circle
                    </v-icon>
                  </v-flex>
                  <v-flex xs1 align-self-center="true">  
                    <Xlsx filename="assumptions" :items="xlsxItems"  :headers="xlsxHeaders" />                                      
                  </v-flex> 
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalAssumptionUSDAmountFormatted}} USD                   
                  </v-flex>  
                  <v-flex xs1 align-self-center="true">
                  Total:  
                  </v-flex>
                  <v-flex xs2 align-self-center="true">
                    {{ totalAssumptionAmountFormatted}} TRY                   
                  </v-flex>     
                  <v-flex xs2 align-self-baseline="center">
                    <v-combobox
                      :items="filterCategoryList"
                      label="Filter By Category"
                      v-model="selectedCategoriesFilter"
                      item-text="text"
                      multiple
                      chips
                      return-object
                    ></v-combobox> 
                  </v-flex>
                  <v-flex xs1 align-self-baseline="center">
                    <v-combobox
                      :items="filterStatusList"
                      label="Filter By Status"
                      v-model="selectedStatusFilter"
                      item-text="text"
                      multiple
                      chips
                      return-object
                    ></v-combobox> 
                  </v-flex>
                  <v-flex xs1 align-self-baseline="center">
                    <v-icon                  
                      @click="filterAssumptions">
                      mdi-refresh
                    </v-icon>
                  </v-flex> 
                </v-layout>  
              </template> 
              <template v-slot:body.append>                    
              </template>          
              <template v-slot:item.remainingFormatted="{ item }">                            
                <div v-bind:class="{ assumptionExceeded : item.exceeded }">
                  {{item.remainingFormatted}}             
                </div>
              </template> 
              <template v-slot:item.showApprovalStatus="{ item }">                 
                <a  @click.prevent="showApprovalStatus(item)" :class="getStatusColor(item)"
                >{{ item.statusText}}</a>    
              </template> 
              <template v-slot:item.showCommentStatus="{ item }">                 
                <v-icon   
                  v-if="item.takenActions.some(action => action.actionType === 'comment')"
                  :key="item.id"
                  @click="showApprovalStatus(item)">
                  mdi-comment-processing
                </v-icon> 
              </template>     
              <template v-slot:item.assumptionsActions="{ item }" >    
                <v-icon   
                  v-for="actionItems in item.actions"      
                  :key="actionItems[0]"
                  @click="takeAction(item, actionItems[0])"
                  :color=actionItems[3]>
                  {{`${actionItems[2]}`}} 
                </v-icon> 
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
    </v-container>
</template>


<script>
import LeftMenu from '../components/LeftMenu';
import DatePicker from '../components/DatePicker';
import Progress from '../components/Progress';
import Xlsx from '../components/Xlsx';
import formatPrice from '../helpers/formatter';
import formatToDouble from '../helpers/formatToDouble';

const API_URL = 'budgetAssumptions';
const CURRENCIES_API_URL = 'definitions/currencies';
const CATEGORIES_API_URL = 'definitions/expenseCategories/masterCategory';
const ALL_CATEGORIES_API_URL = 'definitions/expenseCategories';
const MASTER_CATEGORIES_API_URL = 'definitions/expenseCategories/masterCategories';
const PERSONNEL_API_URL = 'definitions/personnel';
const DEPARTMENTS_API_URL = 'definitions/departments';
const PERIODS_API_URL = 'definitions/periods/withFutures';
export default {
    components:{
      LeftMenu,
      DatePicker,
      Progress,
      Xlsx
    },
    data () {
    return {
      dialog: false,
      approvalDialog: false,
      commentDialog: false,
      search: '',
      showProgress : false,
      assumptionSelectedEndDate: {},
      assumptionSelectedStartDate: {},
      totalAssumptionAmount: 0,
      totalAssumptionAmountUSD: 0,
      selectedAssumptions : [],
      periodList: [],
      departmentList: [],
      categoryList: [],
      masterCategoryList: [],
      allCategoryList: [],
      selectedCategoriesFilter: [],
      selectedStatusFilter: [],
      currencyList: [],
      bankAccountList: [],
      selectedMasterCategory: '',
      assumptions: [],
      editedIndex: -1,
      currentApprovalAction:{},
      editedItem: {
        category: '',
        amount: 0,
      },
      defaultItem: {
        category: '',
        amount: 0, 
      },
      approvalDialogItem:{

      },
      commentDialogValue : '',
      xlsxHeaders: {
        id : 'Assumption Id' ,
        expenseDate : 'Assumption Date' ,
        category : 'Category'  ,
        explanation : 'Explanation' ,       
        amount : 'Amount' ,        
        currency : 'Currency'
      }
    }
  },
  computed: {
    headers () {
      return [
        {text: 'Id',align: 'left',sortable: true,value: 'id'},
        { text: 'Created At', value: 'assumptionDate' },
        { text: 'Creator', value: 'personnelNameSurname' },
        { text: 'Status', value: 'showApprovalStatus' },
        { text: '', value: 'showCommentStatus' },
        { text: 'Period', value: 'period.text' },
        { text: 'Department',  value: 'department.name'  },   
        { text: 'Category',  value: 'expenseCategory.text'  }, 
        { text: 'Title',align: 'left',sortable: true,value: 'title'},      
        { text: 'Amount', align: 'right', value: 'amountFormatted' , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },    
        { text: 'Remaining', align: 'right', value: 'remainingFormatted' , sort: (a, b) =>  formatToDouble(a) - formatToDouble(b) },        
        { text: 'Currency', value: 'currency.code' },
        { text: 'ApprovalActions', value: 'assumptionsActions', sortable: false },
      ]
    },
    approvalHeaders () {
      return [
        { text: 'Action Date', value: 'actionDate' },
        { text: 'Action Type', value: 'actionType' },
        { text: 'Action User', value: 'personnel.name'  },  
        { text: 'Comment', value: 'comment'  }, 
      ]
    },
    xlsxItems(){
      return this.assumptions.map((item) => {
        return {
          id: item.id,
          assumptionDate: item.assumptionDate,
          category: item.expenseCategory.text,
          explanation: item.explanation,
          amount: formatPrice(item.amount) ,
          currency: item.currency.code                   
        }
      });
    },
    filterCategoryList(){
      let newList = this.allCategoryList;
      newList.push({id:0,text:""});
      return newList;
    },
    filterStatusList(){
      let newList = [];
      
      newList.push({code:"APPROVED" ,text:"Approved"});
      newList.push({code:"WAITING_APPROVAL" ,text:"Waiting Approval"});
      newList.push({code:"REJECTED" ,text:"Rejected"});
      newList.push({code:"NEW" ,text:"New"});
      return newList;
    },
    totalAssumptionUSDAmountFormatted(){
      return formatPrice(this.totalAssumptionAmountUSD);
    },
    totalAssumptionAmountFormatted(){
      return formatPrice(this.totalAssumptionAmount);
    },
    assumptionsFormatted(){
      return this.assumptions.map((item) => {
        item.amountFormatted = formatPrice(item.amount);
        item.remainingFormatted = formatPrice(item.remaining);
        item.personnelNameSurname = item.personnel.name +" "+ item.personnel.surname;
        item.isSelectable = (item.statusCode == "WAITING_APPROVAL" && item.actions.map( itemArr => itemArr[0] ).includes("approveItem"));
        return item;  
      })
    },
    currencyListWithText(){
      return this.currencyList.map((item) => {
        return {
          id: item.id,
          code: item.code,
          text: item.code+' - '+item.text          
        };
      })
    },
    formTitle () {
      return this.editedIndex === -1 ? 'New Assumption' : 'Edit Assumption'
    },
    approvalDialogTitle(){
      return "Approval Status";
    },
    commentDialogTitle(){
      return "Please enter comment";
    }
  },
  created() {        
    this.showProgress = true;
    this.getMasterCategories();
    this.getAllCategories();
    this.getCurrencies();
    this.getPerformancePeriodList();
    this.getDepartmentList();
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    approvalDialog (val) {
      val || this.closeApprovalDialog()
    },
    commentDialog (val) {
      val || this.closeCommentDialog()
    },
  },
  methods: {
    createDefaults(){
      if(!this.assumptionSelectedStartDate || ! this.assumptionSelectedEndDate
         || (this.assumptionSelectedStartDate != this.assumptionSelectedEndDate)){
        alert('Please select single period; Start Date and End Date should be same');
        return;
      }

      console.log(this.assumptionSelectedStartDate.defaultsCreated);

      if(this.assumptionSelectedStartDate.defaultsCreated){
        alert('Defaults already created for this period');
        return;
      }

      this.$axios.post(this.$apiurl + API_URL+'/createDefaults/'+this.assumptionSelectedStartDate.id)
      .then(response => {
        this.filterAssumptions();
        this.assumptionSelectedStartDate.defaultsCreated = true;
        this.$radio.$emit('success', {message:'Defaults Created'});
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    assumptionStartPeriodChanged(item){    
      this.assumptionSelectedStartDate = item;  
      if(this.assumptionSelectedEndDate){
        this.filterAssumptions();
      }      
    },
    assumptionEndPeriodChanged(item){
      this.assumptionSelectedEndDate = item;
      if(this.assumptionSelectedStartDate){
        this.filterAssumptions();
      }  
    },
    filterAssumptions (){
      var selectedFilters = [];
      var selectedFiltersStatus = [];
      if(this.assumptionSelectedStartDate && this.assumptionSelectedEndDate){  
        this.showProgress = true;       
        if(this.selectedCategoriesFilter && this.selectedCategoriesFilter.length > 0){
          selectedFilters = Array.from(this.selectedCategoriesFilter, x => x.code);
        }
        if(this.selectedStatusFilter && this.selectedStatusFilter.length > 0){
          selectedFiltersStatus = Array.from(this.selectedStatusFilter, x => x.code);
        }
        this.getAssumptionsByIntervalAndCategory(this.assumptionSelectedStartDate.id,this.assumptionSelectedEndDate.id,selectedFilters,selectedFiltersStatus);
      }else{
        alert('Please select Start Date, End Date and Category');
      }
    },
    editItem (item) {      
      this.selectedMasterCategory = item.expenseCategory.masterCategory;
      this.editedIndex = this.assumptions.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem (item) {
      const index = this.assumptions.indexOf(item)
      if(confirm('Are you sure you want to delete this item?')){
        this.assumptions.splice(index, 1);
        this.deleteAssumption(item);
      } 
    },

    close () {
      this.selectedMasterCategory = '';
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    showApprovalStatus(item){
      this.approvalDialog = true;
      this.approvalDialogItem = Object.assign({}, item)
    },

    closeApprovalDialog(){
        this.approvalDialog = false;
        this.approvalDialogItem = Object.assign({}, this.defaultItem)
    },

    showCommentDialog(item){
      this.currentApprovalAction = Object.assign({}, item);
      this.commentDialog = true;
      this.commentDialogValue = '';
    },

    closeCommentDialog(){
      this.currentApprovalAction = Object.assign({}, {});
      this.commentDialog = false;
      this.commentDialogValue = '';
    },
    save () {
      if(!this.editedItem.period){
        alert('Period cannot be empty!');
        return;
      } 
      if(!this.editedItem.expenseCategory){
        alert('Category cannot be empty!');
        return;
      }     
      if(!this.editedItem.amount){
        alert('Amount cannot be empty!');
        return;
      }   
      if(!this.editedItem.currency){
        alert('Currency cannot be empty!');
        return;
      } 
      if(!this.editedItem.department){
        alert('Department cannot be empty!');
        return;
      } 
      if(!this.editedItem.title){
        alert('Title cannot be empty!');
        return;
      }
      if(!this.editedItem.explanation){
        alert('Explanation cannot be empty!');
        return;
      }

      if (this.editedIndex > -1) {        
        this.updateAssumption(this.editedItem);
      } else {
        this.addAssumption(this.editedItem);         
      }      
    },
    addAssumption(item){      
      this.showProgress = true;
      this.$axios.post(this.$apiurl + API_URL, {
        currencyId: item.currency.id,
        performancePeriodId: item.period.id,
        expenseCategoryId: item.expenseCategory.id,
        amount: item.amount,
        departmentId: item.department.id,
        assumptionDate:item.assumptionDate,
        title: item.title, 
        explanation: item.explanation, 
        performancePeriodId : item.period.id
      })
      .then(response => {        
        if (response.status === 201) {
          this.filterAssumptions();
          this.$radio.$emit('success', {message:'Assumption Created Successfully'});
          this.close();
        } 
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    updateAssumption(item){
      this.showProgress = true;
      let that = this;
      this.$axios.put(this.$apiurl + API_URL, {
        id: item.id,
        currencyId: item.currency.id,
        performancePeriodId: item.period.id,
        expenseCategoryId: item.expenseCategory.id,
        amount: item.amount,
        departmentId: item.department.id,
        assumptionDate:item.assumptionDate,
        title: item.title, 
        explanation: item.explanation, 
        performancePeriodId : item.period.id
      })
      .then(response => {
        if (response.status === 200) {
          this.filterAssumptions();
          this.$radio.$emit('success', {message:'Assumption Updated Successfully'});
          this.close();
        }         
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    takeAction(item, targetFunction){
      item.targetFunction = targetFunction;
      if(targetFunction=='editItem'){
        this.editItem(item);
      }else if(targetFunction=='deleteItem'){
        this.deleteItem(item);
      }else if(targetFunction=='sendToApproval'){
        this.sendToApproval(item);
      }else if(targetFunction=='approveItem'){
        this.approve(item);
      }else if(targetFunction=='rejectItem'){
        this.showCommentDialog(item);
      }else if(targetFunction=='revertAction'){
        this.deleteAction(item);
      }else if(targetFunction=='comment'){
        this.showCommentDialog(item);
      }
    },
    saveComment(){
      if(this.currentApprovalAction.targetFunction=='rejectItem'){
        this.reject(this.currentApprovalAction);
      }else if(this.currentApprovalAction.targetFunction=='comment'){
        this.comment(this.currentApprovalAction);
      } 
    },
    sendToApproval(item){
      this.postAction(item, 'sendToApproval');
    },
    approve(item){
      this.postAction(item, 'approveItem');
    },
    approveAll(){
      this.postBulkAction('approveItem');
    },
    reject(item){
      this.postAction(item, 'rejectItem');
    },
    comment(item){
      this.postAction(item, 'comment');
    },
    bankAccountSelected(item){      
      this.editedItem.currency = item.currency;
    },
    deleteAction(item){
      this.$axios.delete(this.$apiurl + API_URL+'/action/'+item.id)
      .then(response => {
        this.filterAssumptions();
        this.$radio.$emit('success', {message:'Last Action Deleted'});
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },   
    deleteAssumption(item){
      this.$axios.delete(this.$apiurl + API_URL+'/'+item.id)
      .then(response => {
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },    
    postAction(item, action){ 
        this.$axios.post(this.$apiurl + API_URL+'/action', { 
          assumptionId: item.id,
          actionType: action,         
          comment: this.commentDialogValue            
        })
      .then(response => {
        this.closeCommentDialog();
        this.filterAssumptions();
        this.$radio.$emit('success', {message:'Assumption Updated: '+ action});
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    postBulkAction(action){ 
        this.$axios.post(this.$apiurl + API_URL+'/action', { 
          assumptionId: 0,
          assumptionIdList : Array.from(this.selectedAssumptions, x => x.id),
          actionType: action,         
          comment: this.commentDialogValue            
        })
      .then(response => {
        this.selectedAssumptions = [];
        this.closeCommentDialog();
        this.filterAssumptions();
        this.$radio.$emit('success', {message:'Assumption Updated: '+ action});
      }) 
      .catch(error => {
        console.log(error);
      }); 
    },
    getAssumptionsByIntervalAndCategory(startPeriodId, endPeriodId,selectedFilters, selectedFiltersStatus){
      this.$axios.post(this.$apiurl + API_URL+"/filter/assumptionCategories", {             
            startPeriodId: startPeriodId,
            endPeriodId: endPeriodId,
            categories : selectedFilters,
            statusList : selectedFiltersStatus                 
          })
          .then(response => {
            this.totalAssumptionAmount = response.data.totalAmount;
            this.totalAssumptionAmountUSD = response.data.totalAmountUSD;
            this.assumptions = response.data.budgetAssumptionList;
            this.showProgress = false;
          }) 
          .catch(error => {
              console.log(error);
          });  
    },
    getMasterCategories(){     
        this.$axios.get(this.$apiurl + MASTER_CATEGORIES_API_URL)
            .then(response => {
                this.masterCategoryList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getAllCategories(){     
        this.$axios.get(this.$apiurl + ALL_CATEGORIES_API_URL)
            .then(response => {
                this.allCategoryList = response.data;            
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCategoriesByMaster(master){         
        this.$axios.get(this.$apiurl + CATEGORIES_API_URL+'/'+master)
            .then(response => {
                this.categoryList = response.data
                this.editedItem.category = this.categoryList[0];  
            })
            .catch(error => {
                console.log(error);
            });                         
    },
    getPerformancePeriodList(){     
        this.$axios.get(this.$apiurl+PERIODS_API_URL)
            .then(response => {
                this.periodList = response.data;
                this.assumptionSelectedStartDate = this.periodList[0];
                this.assumptionSelectedEndDate =  this.periodList[0];
                this.filterAssumptions();
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getDepartmentList(){     
        this.$axios.get(this.$apiurl+DEPARTMENTS_API_URL)
            .then(response => {
                this.departmentList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getCurrencies(){     
        this.$axios.get(this.$apiurl + CURRENCIES_API_URL)
            .then(response => {
                this.currencyList = response.data
            }) 
            .catch(error => {
                console.log(error);
            });                         
    },
    getStatusColor(item){
      if(item.statusCode === 'APPROVED'){
        return 'assumptionApproved';
      }else if(item.statusCode === 'REJECTED'){
        return 'assumptionRejected';
      }
      return 'assumptionNormal';
    },
    filterOnlyCapsText (value, search) {
      return value != null &&
        search != null &&
        typeof value === 'string' &&
        value.toString().toLocaleUpperCase().indexOf(search.toLocaleUpperCase()) !== -1
    },
  },
}
</script>
<style scoped>
  .assumptionExceeded{
    color:red;
  }

  .assumptionApproved{
    color:green;
  }

  .assumptionRejected{
    color:red;
  }

  .assumptionNormal{
    color:blue;
  }

</style>
